const translations = {
    en: {
        shared: {
            footer: {
                hotel_text_communications: "For any request about your stay you can write to ${hotel_email}",
                privacy_text_communications: "For privacy and GPDR related communications only, you can contact us at ${privacy_email}",
                ownership: 'BWH℠ hotels are independently owned and operated.'
                // mail_unsubscribe: "If you prefer not to receive any more communications from Best Western Italia",
                // mail_unsubscribe_link: "click here to unsubscribe"
            }
        }
    },
    de: {
        shared: {
            footer: {
                hotel_text_communications: "Für alle Anfragen zu Ihrem Aufenthalt können Sie an ${hotel_email} schreiben",
                privacy_text_communications: "Im Gegenteil können Sie uns ausschließlich für Mitteilungen zum Datenschutz oder zur DSGVO unter ${privacy_email} kontaktieren",
                ownership: 'BWH℠ hotels are independently owned and operated.'
                // mail_unsubscribe: "Falls Sie keine Informationen über Best Western Italia mehr erhalten möchten",
                // mail_unsubscribe_link: "klicken Sie hier zu abmeldungen"
            }
        }
    },
    es: {
        shared: {
            footer: {
                hotel_text_communications: "Para cualquier solicitud relacionada con su estadía, puede escribir a ${hotel_email}",
                privacy_text_communications: "En cambio, exclusivamente para comunicaciones relacionadas con la privacidad o GDPR, puede contactarnos en ${privacy_email}",
                ownership: 'BWH℠ hotels are independently owned and operated.'
                // mail_unsubscribe: "Si no quiere recibir mas comunicaciones de Best Western Italia",
                // mail_unsubscribe_link: "Pulse aqui para cancelar su suscripción "
            }
        }
    },
    fr: {
        shared: {
            footer: {
                hotel_text_communications: "Pour toute demande relative à votre séjour vous pouvez écrire à ${hotel_email}",
                privacy_text_communications: "Au lieu de cela, exclusivement pour les communications relatives à la confidentialité ou au RGPD, vous pouvez nous contacter à ${privacy_email}",
                ownership: 'BWH℠ hotels are independently owned and operated.'
                // mail_unsubscribe: "Si vous préférez ne plus recevoir de communications de Best Western Italy",
                // mail_unsubscribe_link: "cliquez ici pour vous désabonner"
            }
        }
    },
    it: {
        shared: {
            footer: {
                hotel_text_communications: "Per qualsiasi richiesta relativa al tuo soggiorno puoi scriverci a ${hotel_email}",
                privacy_text_communications: "Esclusivamente per comunicazioni inerenti privacy o GDPR, puoi contattarci a ${privacy_email}",
                ownership: 'BWH℠ hotels are independently owned and operated.'
                // mail_unsubscribe: "Nel caso non volessi più ricevere informazioni da Best Western Italia",
                // mail_unsubscribe_link: "clicca qui per essere cancellato"
            }
        }
    }
};

export default translations;



// WEBPACK FOOTER //
// ./translations/shared/Footer.js